// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.svg-icon[data-v-0f7d69c8]{width:2.4rem;height:2.4rem}.wrapper[data-v-0f7d69c8]{display:flex;align-items:flex-end}.button-input[data-v-0f7d69c8]{padding:2rem;margin-left:.8rem}.button-input svg[data-v-0f7d69c8]{display:block;margin-bottom:unset}.input-select[data-v-0f7d69c8]{flex-grow:1;max-width:calc(100% - 7.2rem - 2px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
